import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/blog/_componentes/Blog.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contacto/_componentes/Formulario.jsx");
